import React from 'react';
import Skeleton, { SkeletonProps, SkeletonTheme, SkeletonThemeProps } from 'react-loading-skeleton';

import { range } from '@utils/array';

import './TransactionListSkeleton.scss';

interface TransactionListSkeletonProps {
    panelCount?: number;
}

const NegativeSkeletonTheme = (props: SkeletonThemeProps) => {
    const GREY_LIGHT = '#f7f4f2';
    return <SkeletonTheme baseColor="#fff" highlightColor={GREY_LIGHT} {...props} />;
};

const SkeletonWithRoundedBorder = (props: SkeletonProps) => (
    <Skeleton
        style={{
            borderRadius: '20px',
        }}
        {...props}
    />
);

const TransactionItemContentSkeleton = () => (
    <div
        style={{
            flex: 1,
        }}
    >
        <SkeletonWithRoundedBorder />
        <SkeletonWithRoundedBorder width="30%" />
    </div>
);

const TransactionItemSkeleton = () => (
    <div className="transaction-list-content-skeleton">
        <div
            className="transaction-list-transaction-item"
            style={{
                display: 'flex',
                gap: '20px',
            }}
        >
            <TransactionItemContentSkeleton />
        </div>
    </div>
);

const TransactionListSkeleton = ({ panelCount = 3 }: TransactionListSkeletonProps) => (
    <NegativeSkeletonTheme>
        <div id="transaction-list-skeleton">
            {range(panelCount).map((index) => (
                <TransactionItemSkeleton key={index} />
            ))}
        </div>
    </NegativeSkeletonTheme>
);

export default TransactionListSkeleton;
